module.exports = __webpack_public_path__ + "img/kitchen.8b1fefda.jpg";